module.exports = __webpack_public_path__ + "img/linkedin.c28742c0.svg";